var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFolder = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.83337C1 2.82061 1.82061 2 2.83337 2H6.39711C7.09143 2 7.72608 2.39226 8.03673 3.01356L8.43045 3.80101H13.1666C14.1794 3.80101 15 4.62161 15 5.63437V11.9154C15 12.9281 14.1794 13.7487 13.1666 13.7487H2.83337C2.34696 13.7487 1.88105 13.5556 1.53725 13.2125L1.53621 13.2115C1.19314 12.8677 1 12.4018 1 11.9154V3.83337ZM8 4.49749L7.37704 4.80896L7.34521 4.74529C7.33753 4.72992 7.35033 4.75553 7.34262 4.74011L6.79082 3.63651C6.71605 3.48698 6.56366 3.39296 6.39711 3.39296H2.83337C2.58992 3.39296 2.39296 3.58992 2.39296 3.83337V11.9154C2.39296 12.0321 2.43918 12.1441 2.52174 12.2271C2.60473 12.3096 2.7167 12.3558 2.83337 12.3558H13.1666C13.4101 12.3558 13.607 12.1588 13.607 11.9154V5.63437C13.607 5.39093 13.4101 5.19397 13.1666 5.19397H8.00034L8 4.49749ZM8 4.49749L8.00034 5.19397C7.73654 5.19397 7.49502 5.04491 7.37704 4.80896L8 4.49749Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folder.9a7e5602.svg";
export { ForwardRef as ReactComponent };